import { IconBrandFacebook, IconBrandInstagram, IconBrandLinkedin, IconBrandWhatsapp, IconMail, IconNetwork, IconWorldWww } from "@tabler/icons-react";

export const RRSS_KEYS = ['facebook', 'instagram', 'linkedin', 'whatsapp'];

export const RRSS_DEFAULT = Object.fromEntries(RRSS_KEYS.map(key => [key, '']));


export const RRSS_FIELDS = [
    { key: 'facebook', label: 'Facebook', icon: IconBrandFacebook, placeholder: 'https://facebook.com/usuario' },
    { key: 'instagram', label: 'Instagram', icon: IconBrandInstagram, placeholder: 'https://instagram.com/usuario' },
    { key: 'linkedin', label: 'LinkedIn', icon: IconBrandLinkedin, placeholder: 'https://linkedin.com/in/usuario' },
    { key: 'whatsapp', label: 'WhatsApp', icon: IconBrandWhatsapp, placeholder: 'https://wa.me/549...' },
    { key: 'website', label: 'Pagina personal', icon: IconWorldWww, placeholder: 'https://profesor-docente.com.ar' },
];